import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Chip, Button, Card, CardContent, Divider, Stack, useMediaQuery, useTheme } from '@mui/material';
import DataGridTable from './DataGridTabel';
import { dateConverter } from '../utils/dateConveter';
import { useSelector } from 'react-redux';
import Label from './label';
import TransactionDetailsModal from './modals/TransactionDetailsModal';
import AcceptOfferModal from './modals/AcceptOfferModal';
import tokenTransferServices from '../services/tokenTransferServices';
import CompletePaymentModal from './modals/CompletePaymentModal';
import MnemonicUploadModal from './modals/MnemonicUploadModal';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import {BridgeTransactionDetails} from './TranferHistory'
export default function TokenTransfer({peerToPeerTransactions,getTokenTransferTransactions,title,url}) {
  const { enqueueSnackbar } = useSnackbar();
  const [tab, setTab] = useState(0);
  const user = useSelector(state=>state.user.data);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [acceptOfferModalOpen, setAcceptOfferModalOpen] = useState(false);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [viewPaymentModalOpen, setViewPaymentModalOpen] = useState(false);
  const [mnemonicModalOpen, setMnemonicModalOpen] = useState(false);
  const [mnemonicData, setMnemonicData] = useState(null);
  const [isOptin, setIsOptin] = useState(false);
  const [trnasactionId, setTrnasactionId] = useState(null);
  const [openedBy, setOpenedBy] = useState(null);
  // const [openDetails, setOpenDetails] = useState(false);
  const navigate = useNavigate();
  const investorId = useSelector(state=>state.user.data?._id);
  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

const updateddataofsender = peerToPeerTransactions?.sender?.map(item=>{
  return {
    ...item,
    assetName:item.listing?.title,
    offerDate:dateConverter({value: item.created_at, momentIsTrue: true, dateFormat: "DD/MM/YYYY"}),
    tokens:item.numberOfToken+"-"+item?.tokenName,
    image:user?.url+item?.listingImage
  }
})
const updateddataofreceiver = peerToPeerTransactions?.receiver?.map(item=>{
  return {
    ...item,
    assetName:item.listing?.title,
    offerDate:dateConverter({value: item.created_at, momentIsTrue: true, dateFormat: "DD/MM/YYYY"}),
    tokens:item.numberOfToken+"-"+item.tokenName,
    image:user?.url+item?.listingImage
  }
})
// Get status color and variant for Label component
const getStatusColor = (status) => {
  switch (status) {
    case 'COMPLETED':
      return { color: 'success', variant: 'filled', label: 'Transaction Complete' };
    case 'OPTIN_PENDING':
      return { color: 'info', variant: 'filled', label: 'Awaiting Receiver Opt-In' };
    case 'OPTIN_COMPLETED':
      return { color: 'info', variant: 'filled', label: 'Receiver Opted In' };
    case 'OFFER_REJECTED_BY_SENDER':
      return { color: 'error', variant: 'filled', label: 'Transaction Cancelled' };
    case 'FAILED':
      return { color: 'error', variant: 'filled', label: 'Transaction Failed' };  
    default:
      return { color: 'default', variant: 'filled', label: 'Pending' };
  }
};
const getStatusForReceiverColor = (status) => {
  switch (status) {
    case 'COMPLETED':
      return { color: 'success', variant: 'filled', label: 'Tokens Received Successfully' };
    case 'OPTIN_PENDING':
      return { color: 'info', variant: 'filled', label: 'Opt-in Pending' };
    case 'OPTIN_COMPLETED':
      return { color: 'info', variant: 'filled', label: 'Opt-In Successful' };
    case 'OFFER_REJECTED_BY_SENDER':
      return { color: 'error', variant: 'filled', label: 'Transfer Cancelled ' };
    case 'FAILED':
      return { color: 'error', variant: 'filled', label: 'Transaction Failed' };  
    default:
      return { color: 'default', variant: 'filled', label: 'Pending' };
  }
};

const handleCheckPayment = (transaction) => {
    console.log("transactions" , transaction)

  setSelectedTransaction(transaction);
  setModalOpen(true);
};

const handleCloseModal = () => {
  setModalOpen(false);
  setSelectedTransaction(null);
};

const handleAcceptOffer = (offer) => {
  setSelectedOffer(offer);
  setAcceptOfferModalOpen(true);
};

const handleRejectOffer = async (transactionId,status) => {
  try{
      const response = await tokenTransferServices.statusUpdate({transactionId,status});
      if(response.success){
        enqueueSnackbar('Status updated successfully', { variant: 'success' });
      getTokenTransferTransactions();
    }else{
      enqueueSnackbar(response.message, { variant: 'error' });
    }
    }catch(error){
      enqueueSnackbar('Something went wrong', { variant: 'error' });
    }
};
const handleCloseViewPaymentModal = () => {
  setViewPaymentModalOpen(false);
  setSelectedTransaction(null);
};

const handleCloseAcceptOfferModal = () => {
  setAcceptOfferModalOpen(false);
  setSelectedOffer(null);
};

const handleOfferSuccess = () => {
  // Refresh the transactions list after successful action
  getTokenTransferTransactions && getTokenTransferTransactions();
};

const handleCloseMnemonicModal = () => {
  setMnemonicModalOpen(false);
  setMnemonicData(null);
  setIsOptin(false);
  setTrnasactionId(null);
  getTokenTransferTransactions();
};  

const handleViewPayment = (transaction) => {
  setSelectedTransaction(transaction);
  setViewPaymentModalOpen(true);
};

// Component to render blockchain logo image
const BlockchainLogo = ({ blockchain }) => {
  const [imageError, setImageError] = React.useState(false);
  
  if (!blockchain) return null;
  
  const chain = blockchain.toUpperCase();
  const isPolygon = chain === 'POLYGON';
  const isAlgorand = chain === 'ALGORAND';
  
  // Try local file first, then fallback to CDN
  const localLogoUrl = isAlgorand
    ? '/assets/images/blockchain/algorand-logo.png' // Add your Algorand logo to public/assets/images/blockchain/
    : null;
  
  // CDN fallback URLs
  const cdnLogoUrl = isPolygon
    ? 'https://cryptologos.cc/logos/polygon-matic-logo.png'
    : isAlgorand
    ? 'https://cryptologos.cc/logos/algorand-algo-logo.png'
    : null;
  
  // Use local if available, otherwise use CDN
  const logoUrl = localLogoUrl || cdnLogoUrl;
  if (!logoUrl) return null;
  
  // Determine which URL to use (local first, then CDN on error)
  const currentUrl = isAlgorand && imageError && cdnLogoUrl ? cdnLogoUrl : logoUrl;
  
  // For Algorand: show logo in black circle with white logo
  if (isAlgorand) {
    return (
      <Box
        sx={{
          width: 20,
          height: 20,
          borderRadius: "50%",
          backgroundColor: '#000000',
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          mr: 0.5,
          verticalAlign: 'middle',
          boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
        }}
      >
        <Box
          component="img"
          src={currentUrl}
          alt={`${blockchain} logo`}
          sx={{
            width: 12,
            height: 12,
            objectFit: 'contain',
            filter: 'brightness(0) invert(1)' // Convert logo to white
          }}
          onError={(e) => {
            if (localLogoUrl && !imageError && cdnLogoUrl) {
              setImageError(true);
              e.target.src = cdnLogoUrl;
            } else {
              e.target.style.display = 'none';
            }
          }}
        />
      </Box>
    );
  }
  
  // For Polygon: show regular logo
  return (
    <Box
      component="img"
      src={currentUrl}
      alt={`${blockchain} logo`}
      sx={{
        width: 16,
        height: 16,
        objectFit: 'contain',
        display: 'inline-block',
        mr: 0.5,
        verticalAlign: 'middle'
      }}
      onError={(e) => {
        e.target.style.display = 'none';
      }}
    />
  );
};

  const TransferCards = ({ rows = [], type }) => {
    if (!rows || rows.length === 0) return null;

    return (
      <Stack spacing={2} sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 3 } }}>
        {rows.map((row) => {
          const shorten = (val) => {
            if (!val || typeof val !== "string") return "-";
            const s = val.trim();
            if (s.length <= 14) return s;
            return `${s.slice(0, 6)}…${s.slice(-6)}`;
          };

          const statusRaw = row.status;
          const derivedStatus =
            type === "sender" &&
            (row.receiverBlockchainNetwork == 'ALGORAND') &&
            (statusRaw === "PENDING" || !statusRaw)
              ? (row.isOptinCompleted ? "OPTIN_COMPLETED" : "OPTIN_PENDING")
              : (statusRaw || (row.isOptinCompleted ? "OPTIN_COMPLETED" : "OPTIN_PENDING"));

          const statusConfig =
            type === "sender"
              ? getStatusColor(derivedStatus)
              : getStatusForReceiverColor(derivedStatus);

          const onPrimaryAction = () => {
            if (type === "sender") {
              handleCheckPayment(row);
              setOpenedBy("sender");
              return;
            }

            // receiver
            if (row.transactionType === "BRIDGETRANSFER") {
              handleCheckPayment(row);
            } else {
              handleViewPayment(row);
            }
            setOpenedBy("receiver");
          };

          const showReceiverViewTransfer =
            (row.receiverBlockchainNetwork === 'ALGORAND' && row.isOptinCompleted) ||
            (row.receiverBlockchainNetwork === 'ALGORAND' && row.status !== 'PENDING') ||
            (row.receiverBlockchainNetwork === 'POLYGON');

          const showReceiverOptin =
            !row.isOptinCompleted &&
            row.receiverBlockchainNetwork == 'ALGORAND' &&
            row.status == 'PENDING';

          const shouldDisableSenderAction =
            row.receiverBlockchainNetwork === "ALGORAND" &&
            row.status === "PENDING" &&
            !row.isOptinCompleted;

          return (
            <Card key={row._id} sx={{ boxShadow: 1, borderRadius: 2 }}>
              <CardContent>
                <Stack
                  direction="row"
                  spacing={1.5}
                  alignItems="flex-start"
                  sx={{
                    "@media (max-width:500px)": { flexDirection: "column" },
                  }}
                >
                  <Box
                    component="img"
                    src={url + row.listingImages}
                    alt="Asset"
                    sx={{
                      width: 92,
                      height: 68,
                      borderRadius: 1.5,
                      objectFit: "cover",
                      flex: "0 0 auto",
                      bgcolor: "background.default",
                      "@media (max-width:500px)": {
                        width: "100%",
                        height: 140,
                      },
                    }}
                  />
                  <Stack spacing={0.4} sx={{ minWidth: 0, flex: 1 }}>
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      title={row.assetName}
                    >
                      {row.assetName}
                    </Typography>
                    <Typography variant="body3" sx={{ color: "text.secondary" }}>
                      Tokens: {row.tokens}
                    </Typography>
                    <Typography variant="body3" sx={{ color: "text.secondary" }}>
                      Offer Date: {row.offerDate}
                    </Typography>
                    <Box sx={{ mt: 0.75 }}>
                      <Label color={statusConfig.color} variant={statusConfig.variant}>
                        {statusConfig.label}
                      </Label>
                    </Box>
                  </Stack>
                </Stack>

                <Divider sx={{ my: 1.5 }} />

                <Stack spacing={1}>
                  <Stack direction="column" justifyContent="space-between" spacing={2} alignItems="center">
                    <Typography variant="label" sx={{ textAlign: "left" }}>Wallet</Typography>
                    <Box sx={{ textAlign: "left" }}>
                      <BlockchainLogo blockchain={row.senderBlockchainNetwork || row.sender?.blockChainNetwork} />
                      <Typography variant="body3" component="span">
                        {type === "sender"
                          ? row.senderDltWalletname
                          : row.sender?.dltAccount?.slice(-10) + "..."}
                      </Typography>
                      <Typography variant="body3" component="span" sx={{ mx: 0.5 }}>
                        →
                      </Typography>
                      <BlockchainLogo blockchain={row.receiverBlockchainNetwork || row.receiver?.blockChainNetwork} />
                      <Typography variant="body3" component="span">
                        {type === "sender"
                          ? (row.receiver?.dltAccount?.slice(-10) + "...")
                          : row.receiverDltWalletname}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack spacing={1} mt={2}>
                  {type === "sender" ? (
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      disabled={shouldDisableSenderAction}
                      onClick={onPrimaryAction}
                    >
                      {(row.receiverBlockchainNetwork === "POLYGON" || row.status == "COMPLETED" || row.status == 'FAILED' || row.status == "OFFER_REJECTED_BY_SENDER")
                        ? "Review Transfer"
                        : "Sign Transfer"}
                    </Button>
                  ) : (
                    <>
                      {showReceiverViewTransfer && (
                        <Button fullWidth variant="outlined" size="small" onClick={onPrimaryAction}>
                          View Transfer
                        </Button>
                      )}
                      {showReceiverOptin && (
                        <Button
                          fullWidth
                          variant="outlined"
                          size="small"
                          onClick={() => {
                            setTrnasactionId(row._id);
                            setMnemonicModalOpen(true);
                            setIsOptin(true);
                          }}
                        >
                          Opt-in
                        </Button>
                      )}
                    </>
                  )}
                </Stack>
              </CardContent>
            </Card>
          );
        })}
      </Stack>
    );
  };

  // Sender table columns
  const senderColumns = [
    {
      field: "listingImages",
      headerName: "Asset Image",
      flex: 1,
      renderCell: (params) => {
        const isPersonal = params.row.sender?.investorId === params.row.receiver?.investorId;
        return (
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                padding: "2px",
              }}
            >
              <img
                src={url+params.row.listingImages}
                alt="Property"
                style={{ width: "100px", height: "auto", borderRadius: "4px" }}
              />
            </div>
            {isPersonal && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                  zIndex: 1
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '8px',
                    left: '-20px',
                    width: '100px',
                    backgroundColor: 'primary.main',
                    transform: 'rotate(-45deg)',
                    transformOrigin: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '0.7rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    PERSONAL
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        );
      },
    },
    { 
      field: "assetName", 
      headerName: "Asset Name", 
      flex: 1.5,
      minWidth: 150
    },
    { 
      field: "tokens", 
      headerName: "Tokens", 
      flex: 1,
      minWidth: 100,
    },
    // {
    //   field: "blockchainNetworks",
    //   headerName: "From → To",
    //   flex: 2,
    //   minWidth: 150,
    //   renderCell: (params) => {
    //     const from = params.row.senderBlockchainNetwork || 'N/A';
    //     const to = params.row.receiverBlockchainNetwork || 'N/A';
    //     const chipSx = {
    //       borderRadius: "18px",
    //       border: "1px solid #E1E5EE",
    //       backgroundColor: "#F7F9FC",
    //       fontWeight: 600,
    //       fontSize: "12px",
    //       textTransform: "uppercase",
    //       color: "#525866",
    //       minWidth: 80,
    //       justifyContent: "center",
    //       letterSpacing: "0.5px",
    //     };
    //     return (
    //       <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, justifyContent: "center" ,marginTop:"10px"}}>
    //         <Chip label={from} size="small" variant="outlined" sx={chipSx} />
    //         <Typography variant="body3" sx={{ fontWeight: 600, color: "#9197A8" }}>
    //           →
    //         </Typography>
    //         <Chip label={to} size="small" variant="outlined" sx={chipSx} />
    //       </Box>
    //     );
    //   }
    // },
    { 
      field: "offerDate", 
      headerName: "Offer Date", 
      flex: 1.5,
      minWidth: 150,
      // renderCell: (params) => dateConverter({value: params.value, momentIsTrue: true, dateFormat: "DD/MM/YYYY"})
    },
    {
      field: "senderDltWalletname",
      headerName: "DLT Wallet (Sender → Receiver)",
      flex:3 ,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap",padding:"10px" }}>
            <BlockchainLogo blockchain={params.row.senderBlockchainNetwork || params.row.sender?.blockChainNetwork} />
            <Typography variant="body3">{params.row.senderDltWalletname}</Typography>
            <Typography variant="body3" sx={{ mx: 0.5 }}>→</Typography>
            <BlockchainLogo blockchain={params.row.receiverBlockchainNetwork || params.row.receiver?.blockChainNetwork} />
            <Typography variant="body3">{params.row.receiver?.dltAccount?.slice(-10)}...</Typography>
          </Box>
        );
      }
    },
    { 
      field: "status", 
      headerName: "Status", 
      flex: 2,
      minWidth: 200,
      renderCell: (params) => {
        let status = params.value;
        if (params.row.receiverBlockchainNetwork == 'ALGORAND' && params.value=="PENDING"||!params.value) {
          status = params.row.isOptinCompleted?'OPTIN_COMPLETED':'OPTIN_PENDING';
        }
        const statusConfig = getStatusColor(status);
        return (
          <Label color={statusConfig.color} variant={statusConfig.variant}>
            {statusConfig.label}
          </Label>
        );
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      minWidth: 150,
      renderCell: (params) => {
        const { status, isOptinCompleted, receiverBlockchainNetwork , tokens } = params.row;

        // NEW CONDITION → Disable + Show Signed Transfer
        const shouldDisableAndShowSigned =
          receiverBlockchainNetwork === "ALGORAND" &&
          status === "PENDING" &&
          !isOptinCompleted;

          // console.log("status" , status , isOptinCompleted ,tokens)

        return(
        <Button variant="contained" size="small" disabled={shouldDisableAndShowSigned} onClick={() => {handleCheckPayment(params.row);setOpenedBy('sender')}}>
         {( receiverBlockchainNetwork === "POLYGON"||params.row.status=="COMPLETED"||params.row.status == 'FAILED'||params.row.status=="OFFER_REJECTED_BY_SENDER")?"Review Transfer":"Sign Transfer"}
        </Button>
      )
    }
    }
  ];

  // Receiver table columns (similar structure but for receiver data)
  const receiverColumns = [
    {
      field: "listingImages",
      headerName: "Asset Image",
      flex: 1,
      renderCell: (params) => {
        const isPersonal = params.row.sender?.investorId === params.row.receiver?.investorId;
        return (
          <Box sx={{ position: 'relative', display: 'inline-block' }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "100%",
                padding: "2px",
              }}
            >
              <img
                src={url+params.row.listingImages}
                alt="Property"
                style={{ width: "100px", height: "auto", borderRadius: "4px" }}
              />
            </div>
            {isPersonal && (
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '80px',
                  height: '80px',
                  overflow: 'hidden',
                  zIndex: 1
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    top: '8px',
                    left: '-20px',
                    width: '100px',
                    backgroundColor: 'primary.main',
                    transform: 'rotate(-45deg)',
                    transformOrigin: 'center',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '2px 0',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  <Typography
                    variant="caption"
                    sx={{
                      color: 'white',
                      fontWeight: 600,
                      fontSize: '0.7rem',
                      letterSpacing: '0.5px'
                    }}
                  >
                    PERSONAL
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        );
      },
    },
    { 
      field: "assetName", 
      headerName: "Asset Name", 
      flex: 1.5,
      minWidth: 150
    },
    { 
      field: "tokens", 
      headerName: "Tokens", 
      flex: 1,
      minWidth: 100,
    },
    // {
    //   field: "blockchainNetworks",
    //   headerName: "From → To",
    //   flex: 2,
    //   minWidth: 150,
    //   renderCell: (params) => {
    //     const from = params.row.senderBlockchainNetwork || 'N/A';
    //     const to = params.row.receiverBlockchainNetwork || 'N/A';
    //     const chipSx = {
    //       borderRadius: "18px",
    //       border: "1px solid #E1E5EE",
    //       backgroundColor: "#F7F9FC",
    //       fontWeight: 600,
    //       fontSize: "12px",
    //       textTransform: "uppercase",
    //       color: "#525866",
    //       minWidth: 80,
    //       justifyContent: "center",
    //       letterSpacing: "0.5px",
    //     };
    //     return (
    //       <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, justifyContent: "center" ,marginTop:"10px"}}>
    //         <Chip label={from} size="small" variant="outlined" sx={chipSx} />
    //         <Typography variant="body3" sx={{ fontWeight: 600, color: "#9197A8" }}>
    //           →
    //         </Typography>
    //         <Chip label={to} size="small" variant="outlined" sx={chipSx} />
    //       </Box>
    //     );
    //   }
    // },
     { 
      field: "offerDate", 
      headerName: "Offer Date", 
      flex: 1.5,
      minWidth: 150,
    },
    {
      field:"receiverDltWalletname",
      headerName: "DLT Wallet (Sender → Receiver)",
      flex: 3,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap",paddingTop:"10px" }}>
            <BlockchainLogo blockchain={params.row.senderBlockchainNetwork || params.row.sender?.blockChainNetwork} />
            <Typography variant="body3">{params.row.sender?.dltAccount?.slice(-10)}...</Typography>
            <Typography variant="body3" sx={{ mx: 0.5 }}>→</Typography>
            <BlockchainLogo blockchain={params.row.receiverBlockchainNetwork || params.row.receiver?.blockChainNetwork} />
            <Typography variant="body3">{params.row.receiverDltWalletname}</Typography>
          </Box>
        );
      }
    },
    { 
      field: "status", 
      headerName: "Status", 
      flex: 2,
      minWidth: 200,
      renderCell: (params) => {
       let status = params.value;
       if (params.value=="PENDING"||!params.value) {
         status = params.row.isOptinCompleted?'OPTIN_COMPLETED':'OPTIN_PENDING';
       }
        const statusConfig = getStatusForReceiverColor(status);
        return (
          <Label color={statusConfig.color} variant={statusConfig.variant}>
            {statusConfig.label}
          </Label>
        ); 
      }
    },
    {
      field: "actions",
      headerName: "Actions",
      flex: 2,
      minWidth: 150,
       renderCell: (params) => {
         const handleOptinClick = () => {
          setTrnasactionId(params.row._id);
           setMnemonicModalOpen(true);
           setIsOptin(true);
         };
 
         return (
          <Box sx={{ display: "flex", gap: "10px", justifyContent: "center", marginTop: "10px" }}>
            {(
              (params.row.receiverBlockchainNetwork === 'ALGORAND' && params.row.isOptinCompleted) ||
              (params.row.receiverBlockchainNetwork === 'ALGORAND'  && params.row.status !='PENDING')||
              (params.row.receiverBlockchainNetwork === 'POLYGON')
            ) && (
              <Button variant="outlined" size="small" 
              // onClick={() => handleViewPayment(params.row)}
              onClick={() =>{
                  params.row.transactionType === 'BRIDGETRANSFER'? handleCheckPayment(params.row): handleViewPayment(params.row);
                  setOpenedBy("receiver");
                }
                
              }
              >
                View Transfer
              </Button>
            )}

            {!params.row.isOptinCompleted && params.row.receiverBlockchainNetwork == 'ALGORAND' && params.row.status =='PENDING' && (
              <Button variant="outlined" size="small" onClick={handleOptinClick}>
                Opt-in
              </Button>
            )}
          </Box>
        );
      }
    }
    
  ];

  // Empty state component
  const EmptyState = ({ message }) => (
  
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: 200,
      flexDirection: 'column'
    }}>
      <Typography variant="h6" color="text.secondary">
        {message}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        No transactions found
      </Typography>
    </Box>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="Peer to Peer Transaction Tabs">
        <Tab label={`Sent (${peerToPeerTransactions?.sender?.length || 0})`} />
        <Tab label={`Received (${peerToPeerTransactions?.receiver?.length || 0})`} />
      </Tabs>
      
      <Box sx={{ mt: 2 }}>
        {tab === 0 && (
          <>
            {peerToPeerTransactions?.sender && peerToPeerTransactions.sender.length > 0 ? (
              isMobile ? (
                <TransferCards rows={updateddataofsender} type="sender" />
              ) : (
                <DataGridTable 
                  initialRows={updateddataofsender} 
                  initialColumns={senderColumns} 
                  initialPageSize={5}
                />
              )
            ) : (
              <EmptyState message="No transfer to sell transactions found" />
            )}
          </>
        )}
        
        {tab === 1 && (
          <>
            {peerToPeerTransactions?.receiver && peerToPeerTransactions.receiver.length > 0 ? (
              isMobile ? (
                <TransferCards rows={updateddataofreceiver} type="receiver" />
              ) : (
                <DataGridTable 
                  initialRows={updateddataofreceiver} 
                  initialColumns={receiverColumns} 
                  initialPageSize={5}
                />
              )
            ) : (
              <EmptyState message="No offer to buy transactions found" />
            )}
          </>
        )}
      </Box>

      {/* Transaction Details Modal */}
      {modalOpen && selectedTransaction?.transactionType === "BRIDGETRANSFER" ? (
        <BridgeTransactionDetails
          open={modalOpen}
          tx={selectedTransaction}
          onClose={handleCloseModal}
          getTransaction={getTokenTransferTransactions}
          openedBy={openedBy}
        />
      ) : (
        <TransactionDetailsModal
          open={modalOpen}
          data={selectedTransaction}
          onClose={handleCloseModal}
          getTransaction={getTokenTransferTransactions}
        />
      )}


      {/* Accept Offer Modal */}
      <AcceptOfferModal
        open={acceptOfferModalOpen}
        data={selectedOffer}
        onClose={handleCloseAcceptOfferModal}
        onSuccess={handleOfferSuccess}
      />

      {/* View Payment Modal */}
      <CompletePaymentModal
        open={viewPaymentModalOpen}
        data={selectedTransaction}
        onClose={handleCloseViewPaymentModal}
        // onSuccess={handleViewPaymentSuccess}
      />

      {/* Mnemonic Upload Modal */}
      <MnemonicUploadModal
        open={mnemonicModalOpen}
        onClose={handleCloseMnemonicModal}
        transactionId={trnasactionId}
        isOptin={isOptin}
      />
    </Box>
  );
}